export const defaultLabelColorPalette = [
	'#67C4FF',
	'#3561EC',
	'#BD31FF',
	'#FD5252',
	'#FF9141',
	'#FECE2F',
	'#BDFFCC',
	'#00BA77',
	'#00AFBA',
	'#8790A3',
	'#C1CBDC',
	'#EAF5FF',
]

export function getRandomLabelColor() {
	const randomLabelColorIndex = Math.floor(Math.random() * defaultLabelColorPalette.length)
	return defaultLabelColorPalette[randomLabelColorIndex]
}
